<nav
  class="fixed top-0 !z-40 w-full bg-[#0F0F10] border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700 h-[67px] flex items-center"
  style="border: 1px solid #203d54"
>
  <div class="w-[100%] py-3 lg:px-5 lg:pl-3">
    <div class="flex items-center justify-between">
      <div class="flex items-center justify-start">
        <div class="flex items-center justify-start rtl:justify-end">
          <a
            href="/projects"
            *ngIf="sidebarOpen"
            class="flex ms-2 md:me-24 !ml-[15px]"
          >
            <img
              src="assets/images/logo.png"
              alt="Construction Logo"
              class="h-[48px] w-[48px] rounded-[8px] ml-[60px]"
            />
          </a>

          <a href="/projects" *ngIf="!sidebarOpen" class="flex ms-2 !ml-[0px]">
            <img
              src="assets/images/logo.png"
              alt="Construction Logo"
              class="h-[48px] w-[48px] rounded-[8px] ml-[0px]"
            />
          </a>

          <!-- Project Menu Tab -->
          <div
            data-dropdown-toggle="dropdown-project"
            (click)="handleProjectMenu()"
            style="
              box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
              cursor: pointer;
              padding: 14px 15px;
            "
            class="bg-[#242628] text-[14px] text-[#fff] ml-[15px] flex h-[51px] !min-w-[189px] !w-[auto] justify-between items-center flex-shrink-0 hover:bg-[#242628] rounded-[10px] !m-50 text-left"
          >
            <div style="font-weight: 500; font-style: normal">
              <span [title]="org_info?.name">{{
                org_info?.name
                  ? (org_info?.name | slice : 0 : 13)
                  : "Organization not found"
              }}</span>
              <br />
              <span style="font-weight: 700" [title]="selectedProject">
                {{ selectedProject ? selectedProject : "Select a Project" }}
              </span>
            </div>
            <div class="!pl-[10px] !pt-[10px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="5"
                viewBox="0 0 11 5"
                fill="none"
              >
                <path d="M0 0L5.1461 5L10.2922 0H0Z" fill="white" />
              </svg>
            </div>
          </div>

          <!-- Company Tools Menu Tab -->
          <div
            style="
              box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
              cursor: pointer;
              padding: 14px 15px;
            "
            class="bg-[#242628] text-[14px] text-[#fff] ml-[15px] flex h-[51px] !w-[189px] justify-between items-center flex-shrink-0 hover:bg-[#242628] rounded-[10px] !m-50 text-left"
          >
            <div style="font-weight: 500; font-style: normal">
              Company Tool
              <br />
              <span style="font-weight: 700"> Portfolio </span>
            </div>
            <div class="!pl-[10px] !pt-[10px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="5"
                viewBox="0 0 11 5"
                fill="none"
              >
                <path d="M0 0L5.1461 5L10.2922 0H0Z" fill="white" />
              </svg>
            </div>
          </div>

          <div
            style="
              box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
              cursor: pointer;
              padding: 14px 15px;
            "
            class="bg-[#242628] text-[14px] text-[#fff] ml-[15px] flex h-[51px] !w-[154px] justify-between items-center flex-shrink-0 hover:bg-[#242628] rounded-[10px] !m-50 text-left"
          >
            <div style="font-weight: 500; font-style: normal">
              Favourites
              <br />
              <span style="font-weight: 700"> Tendering </span>
            </div>
            <div class="!pl-[10px] !pt-[10px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="5"
                viewBox="0 0 11 5"
                fill="none"
              >
                <path d="M0 0L5.1461 5L10.2922 0H0Z" fill="white" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Side section items -->
      <div class="flex items-center">
        <div class="flex items-center ms-3">
          <div class="flex items-center gap-[10px]">
            <app-countries
              [selectedCountry]="org_info?.country"
              [org_info]="org_info"
            ></app-countries>

            <button
              [matMenuTriggerFor]="notificationsSlider"
              class="flex !w-[20px] !h-[20px] text-sm rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
              aria-expanded="false"
              data-dropdown-toggle="dropdown-user"
            >
              <img
                class="!w-[20px] !h-[20px] rounded-full"
                src="assets/icons/notification_icon.svg"
                alt="notification icon"
              />
            </button>
            <div style="position: relative">
              <mat-menu #notificationsSlider="matMenu">
                <div
                  class="notification-header flex items-center justify-center gap-2 p-2 mt-[-10px] text-white"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 27 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.4383 10.4001V22.5295H3.57183V5.64408H15.6876C15.585 5.19099 15.5189 4.72242 15.5189 4.23697C15.5189 3.75151 15.585 3.28295 15.6876 2.82985H3.57183C2.02292 2.82985 0.760742 4.09626 0.760742 5.64408V22.5295C0.760742 24.0773 2.02573 25.3437 3.57183 25.3437H20.4383C21.9844 25.3437 23.2494 24.0773 23.2494 22.5295V10.4001C22.7968 10.5029 22.3288 10.569 21.8439 10.569C21.359 10.569 20.8909 10.5029 20.4383 10.4001ZM21.8439 0.015625C21.2901 0.015625 20.7418 0.124813 20.2302 0.336956C19.7187 0.549098 19.2538 0.86004 18.8623 1.25203C18.4707 1.64402 18.1601 2.10937 17.9482 2.62153C17.7363 3.13369 17.6272 3.68261 17.6272 4.23697C17.6272 4.79132 17.7363 5.34025 17.9482 5.85241C18.1601 6.36456 18.4707 6.82992 18.8623 7.22191C19.2538 7.6139 19.7187 7.92484 20.2302 8.13698C20.7418 8.34912 21.2901 8.45831 21.8439 8.45831C22.9622 8.45831 24.0347 8.01357 24.8255 7.22191C25.6162 6.43025 26.0605 5.35654 26.0605 4.23697C26.0605 3.1174 25.6162 2.04368 24.8255 1.25203C24.0347 0.460372 22.9622 0.015625 21.8439 0.015625Z"
                      fill="#F1F3F5"
                    />
                  </svg>
                  <span
                    class="font-medium text-[18px] text-[#F1F3F5] w-[133.38px]"
                    >Notifications</span
                  >
                </div>
                <mat-list
                  class="w-full max-w-xs bg-gray-50 botder-b rounded-lg p-2"
                >
                  <ng-container
                    *ngIf="
                      notifications && notifications.length > 0;
                      else noNotifications
                    "
                    class="relative"
                  >
                    <!-- Notifications List -->
                    <div
                      class="overflow-y-auto max-h-72 border-b border-gray-300"
                    >
                      <a
                        *ngFor="let notification of notifications"
                        class="flex items-center gap-2 p-3 hover:bg-gray-100 rounded-md transition duration-200 ease-in-out"
                      >
                        <mat-icon class="text-blue-500">notifications</mat-icon>
                        <span
                          [innerHTML]="getSubject(notification)"
                          class="text-sm font-medium text-gray-700 truncate w-full"
                        >
                          <span
                            *ngIf="notification.is_obsolete"
                            class="text-red-500 text-sm font-medium truncate w-full"
                            >(Obsolete)</span
                          >
                        </span>
                      </a>
                    </div>
                    <!-- "View All Notifications" button (fixed at the bottom) -->
                    <div class="absolute bottom-0 w-full">
                      <button
                        mat-menu-item
                        class="view-all-button w-full py-2 font-semibold text-gray-800 hover:text-blue-600 transition-colors duration-200"
                        (click)="navigateTo()"
                      >
                        <span>View All Notifications</span>
                      </button>
                    </div>
                  </ng-container>

                  <ng-template #noNotifications>
                    <div class="text-center py-4 text-gray-500">
                      No notifications available
                    </div>
                  </ng-template>
                </mat-list>
              </mat-menu>
            </div>
            <button
              type="button"
              class="flex !w-[20px] !h-[20px] text-sm rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
              aria-expanded="false"
            >
              <img
                class="w-[20px] h-[20px] rounded-full"
                src="assets/icons/message_icon.svg"
                alt="message icon"
              />
            </button>
            <button
              type="button"
              class="flex w-[28] !h-[28px] text-sm !mb-[4px] rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
              aria-expanded="false"
              data-dropdown-toggle="dropdown-user"
              (click)="setIsProfileMenuOpen()"
            >
              <img
                class="!w-[28px] !h-[28px] rounded-full"
                src="https://flowbite.com/docs/images/people/profile-picture-5.jpg"
                alt="user photo"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Profile panels -->
  <div (document:click)="onOutsideClick($event)">
    <div
      *ngIf="isProfileMenuOpen"
      class="z-50 absolute top-[75px] right-[11px] text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600"
      id="dropdown-user"
    >
      <div class="px-4 py-3" role="none">
        <p class="text-sm text-gray-900 dark:text-white" role="none">
          {{ org_info?.name }}
        </p>
        <p
          class="text-sm font-medium text-gray-900 truncate dark:text-gray-300"
          role="none"
        >
          {{ user_info?.email }}
        </p>
      </div>
      <ul class="py-1 list-none" role="none">
        <li>
          <a
            (click)="navigateToProfile()"
            class="block cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
            role="menuitem"
            >Profile</a
          >
        </li>
        <li>
          <a
            (click)="navigateToUserRoleManagement()"
            class="block cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
            role="menuitem"
            >User Roles Manager</a
          >
        </li>
        <li>
          <a
            href="#"
            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
            role="menuitem"
            >Settings</a
          >
        </li>

        <li>
          <a
            (click)="handleLogOut()"
            class="block cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
            role="menuitem"
            >Log out</a
          >
        </li>
      </ul>
    </div>
  </div>
  <!-- Menu Items -->
  <div
    id="dropdown-project"
    *ngIf="isProjectsMenuOpen"
    class="grid grid-cols-1 md:grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-3 !pt-[20px] !border-style-none z-50 absolute top-[64px] right-[0px] text-base list-none bg-[#1C1F20] rounded shadow dark:bg-gray-700 !w-full !h-[auto] !text-[16px] !pl-[94px] !pr-[104px] text-left !pb-[20px]"
  >
    <!-- Projects Menu Items -->
    <div class="!w-[35%] custom-scrollbar">
      <div class="px-0 py-3 !border-none" role="none">
        <p
          (click)="goToProjects()"
          class="text-sm dark:white !text-[#fff] inline-block cursor-pointer"
          role="none"
        >
          Select a Project
        </p>
        <hr class="w-[35%] border-t border-[#FFF]" />
        <div class="!pt-[0px] !pr-[20px] !h-[300px] !mt-[33px] overflow-y-auto">
          <div *ngFor="let project of projects" class="!h-[fit-content]">
            <li
              class="!cursor-pointer !text-[#FFF] !text-left !text-[14px] hover:bg-[#E76B3F] p-[0.625rem]"
              style="font-style: normal; font-weight: 500"
              (click)="openProject(project)"
              [ngClass]="
                project?.name === selectedProject && projectId === project?.id
                  ? 'bg-[#E76B3F]'
                  : ''
              "
            >
              {{ project.name }}
            </li>
          </div>
          <div>
            <!-- <p
              *ngIf="requestedprojects"
              (click)="goToProjects()"
              class="text-sm text-gray-900 dark:white !text-[#E76B3F] inline-block cursor-pointer font-bold"
              role="none"
            >
              Requested Projects
            </p> -->
            <div *ngFor="let project of requestedprojects">
              <li
                class="flex !cursor-pointer !text-[#FFF] !text-left !text-[14px] hover:bg-[#E76B3F] !hover:text-[#fff] p-[0.625rem] relative"
                style="font-style: normal; font-weight: 500"
                (click)="openRequestedProject(project, 'requested')"
                [ngClass]="
                  project?.name === selectedProject && projectId === project?.id
                    ? 'bg-[#E76B3F]'
                    : ''
                "
              >
                <!-- Dot element -->
                <!-- <span
                  class="absolute left-2 top-1/2 transform -translate-y-1/2 w-2 h-2 rounded-full"
                  [ngClass]="{
                    'bg-white':
                      project?.name === selectedProject &&
                      projectId === project?.id,
                    'bg-[#E76B3F]': !(
                      project?.name === selectedProject &&
                      projectId === project?.id
                    )
                  }"
                ></span> -->
                <!-- Project name -->
                <span>{{ project.name }}</span>
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tools Menu Items -->
    <div
      class="px-0 py-4 grid grid-cols-1 md:grid-cols-4 lg:grid-cols-8 gap-3 absolute right-[0px] text-base !w-[75%] !h-[auto] !text-[16px] text-left !divide-gray-0"
    >
      <!-- Project Brief -->
      <div class="px-0 py-3 !border-style-none" role="none">
        <p
          class="text-sm dark:white !text-[#fff] inline-block relative after:content-[''] after:block after:w-full after:border-t after:border-[#FFF] after:mt-3"
          role="none"
        >
          Project Information
        </p>

        <ul class="!pt-[33px] list-none border-none !pl-0" role="none">
          <li>
            <a
              (click)="redirectPage('/brief-plan-view', 'brief')"
              class="block cursor-pointer px-0 py-2 text-sm text-gray-700 dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Project Brief</a
            >
          </li>
          <li>
            <a
              (click)="redirectPage('/brief-plan-view', 'plan')"
              class="block cursor-pointer px-0 py-2 text-sm text-gray-700 dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Project Plan</a
            >
          </li>
          <li>
            <a
              class="block cursor-pointer px-0 py-2 text-sm text-gray-700 dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Project Estimate</a
            >
          </li>
          <li>
            <a
              class="block cursor-pointer px-0 py-2 text-sm text-gray-700 dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Project Programme</a
            >
          </li>
        </ul>
      </div>

      <!-- Tendering -->
      <div class="px-0 py-3 !border-none" role="none">
        <p
          class="text-sm dark:white !text-[#fff] inline-block relative after:content-[''] after:block after:w-full after:border-t after:border-[#FFF] after:mt-3"
          role="none"
        >
          Tendering
        </p>
        <ul
          class="!pt-[33px] list-none border-none !pl-0 pr-[10px]"
          role="none"
        >
          <li
            [ngClass]="
              selectedSection === 'eoi-requests' ||
              selectedSection === 'eoi-request-detail' ||
              selectedSection === 'eoi-submissions' ||
              selectedSection === 'initiate-eoi'
                ? 'bg-color'
                : ''
            "
          >
            <a
              (click)="
                projectType === 'requested'
                  ? redirectToTendering('/eoi-requests/' + projectId)
                  : redirectToTendering('/eoi-submissions')
              "
              class="block cursor-pointer px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >EOI</a
            >
          </li>
          <li
            [ngClass]="
              selectedSection === 'pqq-requests' ||
              selectedSection === 'applicant-individual-pqq-view' ||
              selectedSection === 'pqq-submissions' ||
              selectedSection === 'initiate-pqq'
                ? 'bg-color'
                : ''
            "
          >
            <a
              (click)="
                projectType === 'requested'
                  ? redirectToTendering('/pqq-requests')
                  : redirectToTendering('/pqq-submissions')
              "
              class="cursor-pointer block px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >PQQ</a
            >
          </li>

          <li
            [ngClass]="
              selectedSection === 'RFP' ||
              selectedSection === 'initiate/rfp' ||
              selectedSection === 'requests/rfp'
                ? 'bg-color'
                : ''
            "
          >
            <a
              (click)="
                projectType === 'requested'
                  ? redirectToTendering('/requests/rfp')
                  : redirectToTendering(projectId + '/tendering/rfp')
              "
              class="block cursor-pointer px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
            >
              <span> RFP </span> <br />
              <span class="text-[11px]"> Q&A </span> <br />

              <span class="text-[11px]"> Addendums </span>
            </a>
          </li>
          <li [ngClass]="selectedSection === 'RFQ' ? 'bg-color' : ''">
            <a
              (click)="
                projectType === 'requested'
                  ? redirectToTendering('/requests/rfq')
                  : redirectToTendering(projectId + '/tendering/rfq')
              "
              class="block cursor-pointer px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
            >
              <span> RFQ </span> <br />
              <span class="text-[11px]"> Q&A </span> <br />
              <span class="text-[11px]"> Addendums </span>
            </a>
          </li>
        </ul>
      </div>

      <!--  Contracts -->
      <div class="px-0 py-3 !border-none" role="none">
        <p
          class="text-sm dark:white !text-[#fff] inline-block relative after:content-[''] after:block after:w-full after:border-t after:border-[#FFF] after:mt-3"
          role="none"
        >
          Contracts
        </p>
        <ul class="!pt-[33px] list-none border-none !pl-0" role="none">
          <li>
            <a
              class="block cursor-pointer px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Contract/PO</a
            >
          </li>
          <li>
            <a
              class="cursor-pointer block px-0 py-2 text-sm dark:text-gray-300 !text-[#fff] ml-[-17px]"
              role="menuitem"
              (click)="toggleMenu()"
            >
              <span
                [ngClass]="{
                  'rotate-90': expandedScopeOfWork,
                  'rotate-0': !expandedScopeOfWork
                }"
                class="transition-transform duration-300 transform inline-block"
              >
                <img
                  src="assets/icons/dropdown-icon.svg"
                  alt="Construction Logo"
                  class=""
                />
              </span>
              <span class="ml-[4px]">Scope of Work</span>
            </a>

            <ul
              class="list-none border-none !pl-0 !h-[184px] overflow-y-auto scrollbar-thin"
              role="none"
              *ngIf="!expandedScopeOfWork"
            >
              <li>
                <a
                  (click)="changeTab('Drawings')"
                  class="block cursor-pointer px-0 pb-[8px] text-[11px] dark:text-gray-300 !text-[#fff]"
                  role="menuitem"
                  >Drawings</a
                >
              </li>
              <li>
                <a
                  (click)="changeTab('Specifications')"
                  class="block cursor-pointer px-0 pb-[8px] text-[11px] dark:text-gray-300 !text-[#fff]"
                  role="menuitem"
                  >Specifications</a
                >
              </li>
              <li>
                <a
                  (click)="changeTab('Calculations')"
                  class="block cursor-pointer px-0 pb-[8px] text-[11px] dark:text-gray-300 !text-[#fff]"
                  role="menuitem"
                  >Calculations</a
                >
              </li>
              <li>
                <a
                  (click)="changeTab('Surveys, Reports and Studies')"
                  class="block cursor-pointer px-0 pb-[8px] text-[11px] dark:text-gray-300 !text-[#fff]"
                  role="menuitem"
                  >Surveys, Reports and Studies</a
                >
              </li>
              <li>
                <a
                  (click)="changeTab('Design Review Reports')"
                  class="block cursor-pointer px-0 pb-[8px] text-[11px] dark:text-gray-300 !text-[#fff]"
                  role="menuitem"
                  >Design Review Reports</a
                >
              </li>
              <li>
                <a
                  (click)="changeTab('Permits and Applications')"
                  class="block cursor-pointer px-0 pb-[8px] text-[11px] dark:text-gray-300 !text-[#fff]"
                  role="menuitem"
                  >Permits and Applications</a
                >
              </li>
              <li>
                <a
                  (click)="changeTab('Design Sign Off')"
                  class="block cursor-pointer px-0 pb-[8px] text-[11px] dark:text-gray-300 !text-[#fff]"
                  role="menuitem"
                  >Design Sign Off</a
                >
              </li>
              <li>
                <a
                  (click)="changeTab('RFI')"
                  class="block cursor-pointer px-0 text-[11px] dark:text-gray-300 !text-[#fff]"
                  role="menuitem"
                  >Submittals</a
                >
              </li>
            </ul>
          </li>
          <li>
            <a
              class="cursor-pointer block px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Variation Orders</a
            >
          </li>

          <li [ngClass]="selectedSection === 'rfi-listing' ? 'bg-color' : ''">
            <a
              (click)="redirectToTendering('/rfi-listing')"
              class="cursor-pointer block px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >RFI</a
            >
          </li>
        </ul>
      </div>

      <!-- Security -->
      <div class="px-0 py-3 !border-none" role="none">
        <p
          class="text-sm dark:white !text-[#fff] inline-block relative after:content-[''] after:block after:w-full after:border-t after:border-[#FFF] after:mt-3"
          role="none"
        >
          Security
        </p>

        <ul class="!pt-[33px] list-none border-none !pl-0" role="none">
          <li>
            <a
              class="block cursor-pointer px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Insurances</a
            >
          </li>
          <li>
            <a
              class="cursor-pointer block px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
            >
              Bonds</a
            >
          </li>
        </ul>
      </div>

      <!-- Commercial -->
      <div class="px-0 py-3 !border-none" role="none">
        <p
          class="text-sm dark:white !text-[#fff] inline-block relative after:content-[''] after:block after:w-full after:border-t after:border-[#FFF] after:mt-3"
          role="none"
        >
          Commercial
        </p>

        <ul class="!pt-[33px] list-none border-none !pl-0" role="none">
          <li>
            <a
              class="block cursor-pointer px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Payments</a
            >
          </li>
          <li>
            <a
              class="cursor-pointer block px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Change Control</a
            >
          </li>
        </ul>
      </div>

      <!-- Operations -->
      <div class="px-0 py-3 !border-none" role="none">
        <p
          class="text-sm dark:white !text-[#fff] inline-block relative after:content-[''] after:block after:w-full after:border-t after:border-[#FFF] after:mt-3"
          role="none"
        >
          Operations
        </p>
        <ul class="!pt-[33px] list-none border-none !pl-0" role="none">
          <li>
            <a
              class="block cursor-pointer px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Time Booking</a
            >
          </li>
          <li>
            <a
              class="cursor-pointer block px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Site Diary</a
            >
          </li>

          <li>
            <a
              class="cursor-pointer block px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Site Attendance</a
            >
          </li>
          <li>
            <a
              class="cursor-pointer block px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Site Delivery Note</a
            >
          </li>
          <li>
            <a
              class="cursor-pointer block px-0 py-2 text-sm dark:text-gray-300 !text-[#fff]"
              role="menuitem"
              >Daily Reports</a
            >
          </li>
        </ul>
      </div>

      <!-- Reports -->
      <div class="px-0 py-3 !border-none" role="none">
        <p
          class="text-sm dark:white !text-[#fff] inline-block relative after:content-[''] after:block after:w-full after:border-t after:border-[#FFF] after:mt-3"
          role="none"
        >
          Reports
        </p>
      </div>

      <!-- Vendors -->
      <div class="px-0 py-3 !border-none" role="none">
        <p
          class="text-sm dark:white !text-[#fff] inline-block relative after:content-[''] after:block after:w-full after:border-t after:border-[#FFF] after:mt-3"
          role="none"
        >
          Vendors
        </p>
      </div>
    </div>

    <!-- Close Button -->
    <button
      (click)="isProjectsMenuOpen = false"
      class="absolute bottom-[12px] right-[12px] text-white px-4 py-2 rounded focus:outline-none flex items-center justify-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
      >
        <path
          d="M9.97501 7.50053L14.6154 2.86004C15.1281 2.34732 15.1281 1.51605 14.6154 1.00411L13.9968 0.385525C13.4839 -0.127319 12.6526 -0.127319 12.1407 0.385525L7.50049 5.02585L2.86004 0.384541C2.34732 -0.12818 1.51605 -0.12818 1.00411 0.384541L0.384541 1.00321C-0.12818 1.5161 -0.12818 2.34736 0.384541 2.85926L5.02577 7.50049L0.385484 12.1409C-0.12736 12.6537 -0.12736 13.485 0.385484 13.9969L1.00411 14.6155C1.51683 15.1282 2.3481 15.1282 2.86004 14.6155L7.50045 9.97505L12.1408 14.6155C12.6537 15.1282 13.4849 15.1282 13.9969 14.6155L14.6155 13.9968C15.1282 13.4839 15.1282 12.6527 14.6155 12.1408L9.97501 7.50053Z"
          fill="white"
        />
      </svg>
    </button>
  </div>
</nav>

<ng-container *ngIf="isProjectOpen">
  <app-wrapper (handleDialog)="handleDialog()"></app-wrapper>
</ng-container>
